import RedirectToPlaylist from './Redirect';

export default RedirectToPlaylist;
